export function userLogin (state, userdata) {
  localStorage.setItem('logged', true)
  localStorage.setItem('token', userdata.token)
  localStorage.setItem('user', JSON.stringify(userdata.user))
  state.logged = true
  state.user = userdata.user
}

export function userResetPass (state, userdata) {
  localStorage.setItem('user', JSON.stringify(userdata.user))
  state.user = userdata.user
}

export function userLogout (state) {
  localStorage.setItem('logged', false)
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  state.logged = false
  state.user = null
  state.userMenu = []
  state.dashdoardWidgets = []
}

export function userLoading (state, loading = false) {
  state.loading = loading
}

export function registered (state, userdata) {
  localStorage.setItem('logged', true)
  localStorage.setItem('token', userdata.token)
  localStorage.setItem('user', JSON.stringify(userdata))
  state.logged = true
  state.user = userdata
}

export function setDashboard (state, widgets = []) {
  state.dashdoardWidgets = widgets
}

export function userData (state, userdata) {
  localStorage.setItem('user', JSON.stringify(userdata))
  state.user = userdata
}

export function setDashboardLoading (state, loading = false) {
  state.dashboardLoading = loading
}

export function setMenu (state, menu = []) {
  state.userMenu = menu
}

export function setMenuLoading (state, loading = false) {
  state.menuLoading = loading
}
